<template>
  <div class="home_container" :style="{backgroundImage: homeBgc}">
    <div v-if="Object.keys(actInfo).length">
      <div class="header_container">
        <div class="logo">
        </div>
        <div class="centerBtn">
          <div class="RuleBtn">
            <!-- <div class="btn_inner" :style="{background: btnBgcColor, color: btnFontColor}">活动规则</div> -->
          </div>
        </div>
        <div class="rightBtn">
          <div class="myGiftBtn" @click="myGiftBtn()">
            <div class="btn_inner" :style="{background: btnBgcColor, color: btnFontColor}">我的奖品</div>
          </div>
        </div>
        <div class="rightIcon"></div>
      </div>
      <!-- new css start:  -->
      <div class="new_content_container">
        <div class="new_content_title">
          <!-- <div class="big_title">{{actInfo.name? actInfo.name: '- -'}}</div> -->
          <!-- <div class="desc_title">{{actInfo.describ? actInfo.describ: '- -'}}</div> -->
        </div>
        <div class="new_content_input_box" :style="{backgroundColor: cardBgc, marginTop: loginBoxFromTheTopValue}">
          <div class="new_content_input" :style="{border: `1px solid ${btnBgcColor}`}">
            <div class="new_content_input_box_inner">
              <van-field v-model.trim="phoneNumber" placeholder="请输入手机号"  @blur="onBlurInput()" />
            </div>
          </div>
          <div class="new_content_input" :style="{border: `1px solid ${btnBgcColor}`}">
            <div class="new_content_input_box_inner">
              <van-field v-model.trim="phoneCode" placeholder="验证码"  @blur="onBlurInput()" maxlength="6" />
            </div>
            <div class="new_content_input_box_inner_getCodeBtn" :style="{borderLeft: `1px solid ${btnBgcColor}`, color: btnBgcColor}" @click="getPhoneCode">{{verifycodeBtnText}}</div>
          </div>
          <div class="new_content_btn">
            <div class="new_content_btn_inner" :style="{background: btnBgcColor, color: btnFontColor}" @click="confirmBtn()">{{actInfo.btnName? actInfo.btnName: "- -"}}</div>
          </div>
          <div class="new_content_btn02" v-if="actInfo.btn2show">
            <div class="new_content_btn_inner02" :style="{background: btnBgcColor, color: btnFontColor}" @click="getMoreGift(actInfo.btn2url)">{{actInfo.btn2Name? actInfo.btn2Name: "- -"}}</div>
          </div>
        </div>
        <div class="new_content_rule_box" :style="{backgroundColor: cardBgc}">
          <div class="new_content_rule_box_title" :style="{color: btnBgcColor}">活动规则</div>
          <div class="new_content_rule_box_content lh22" v-html="actInfo.ruleDescription"></div>
        </div>
      </div>
      <!-- new css end  -->
    </div>

    <!--  @*易盾滑动验证码*@  -->
    <div id="captcha"></div>
    
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";
import URL from "@/utils/url";
import { mapMutations, mapGetters } from "vuex";
import { comment } from "@/mixins/comment.js";
import yidunPopup from "@/utils/yiduncomm.js";
import devicetype from "@/utils/deviceType.js";
export default {
  mixins: [comment],
  data() {
    return {
      phoneNumber: "",
      phoneCode: "",
      expofPhone: /^1[3-9]\d{9}$/,
      verifycodeBtnText: "获取验证码",
      getCodeState: true,

      id: "",
      actInfo: {},
      isPastDue: false,
      confirmBtnFlag: true,
      NECaptchaValidate: null,
      cid: ""
    };
  },

  methods: {
    ...mapMutations([
      'SET_GroundMarketingInfo',
      'Remove_GroundMarketingInfo'
    ]),
    onBlurInput() {
		  window.scroll(0, 0);
    },
    // 获取详情：
    async getDrawDetail() {
      try {
        const toastLoading = Toast.loading({
          message: "正在加载",
          forbidClick: true,
          duration: 0
        });
        // let {data: result} = await this.$get(`/consumer/mkt-activity/get/${this.id}`);
        let {data: result} = await this.$get(`/consumer/mkt-activity/getByCache/${this.id}`);
        if (result.code !== 200) {
          Toast(result.errMsg);
          this.Remove_GroundMarketingInfo();
          return false;
        };
        toastLoading.clear();
        this.actInfo = result.data;
        document.title = this.actInfo.name;
        let info = {
          actInfo: this.actInfo
        }
        // 获取抽奖详情时，判断缓存里面有用户信息需要回显，以便用户连续抽奖，提升用户体验（这个用户信息会自动过期）：
        if (this.getGroundMarketingInfo && this.getGroundMarketingInfo.userInfo) {
          Object.assign(info, {userInfo: this.getGroundMarketingInfo.userInfo});
          this.phoneNumber = this.getGroundMarketingInfo.userInfo.phone;
          // this.phoneCode = this.getGroundMarketingInfo.userInfo.code;
        } else {
          Object.assign(info, {userInfo: null});
        }
        // 有渠道需要缓存渠道：
        // if (this.$route.query.source) Object.assign(info, {source: this.$route.query.source});
        if (this.$route.query.utm_source) Object.assign(info, {source: this.$route.query.utm_source});
        this.SET_GroundMarketingInfo(info);
        if (!this.actInfo.enable) {
          this.isPastDue = true;
          Toast("活动已过期");
        }
      } catch(err) {
        console.log(err);
      }
    },
    // 验证码：
    async getPhoneCode() {
      if (this.isPastDue) return Toast("活动已过期");
      if (this.phoneNumber == "") return Toast("手机号不能为空");
      if (!this.expofPhone.test(this.phoneNumber)) return Toast("手机号格式不正确");
      let sendRandomNumParams = {
        requestSource: devicetype().name,
        pageCode: "login_page",
        caller: "luckDraw",
        NECaptchaValidate: this.NECaptchaValidate,
        phoneNumber: this.phoneNumber,
        actId: this.id
      }
      // 倒计时初始化：
      let codeTime = 60;
      // 节流阀：
      if (!this.getCodeState) return;
      this.verifycodeBtnText = "正在发送";
      let {data: result} = await this.$post(`/consumer/user/sendRandomNum`, sendRandomNumParams);
      this.NECaptchaValidate = null;
      if (result.code !== 200) {
        if (result.data.errCode === '400235') {
          let _that = this;
          // 滑动验证码校验成功后的处理方法：
          yidunPopup(function(err, data) {
            if (err) {
              _that.NECaptchaValidate = null;
              return false;
            }
            _that.NECaptchaValidate = data.validate;
            _that.getPhoneCode();
          })
        } else {
          Toast(result.errMsg);
        }
        this.verifycodeBtnText = "发送验证码";
        return false;
      }
      this.getCodeState = false;
      Toast('验证码已发出');
      this.cid = result.data.cid;
      this.verifycodeBtnText = `重发${codeTime}`;
      let timerId = setInterval(() => {
        codeTime--;
        if (codeTime <= 0) {
          this.verifycodeBtnText = "重新获取";
          clearInterval(timerId);
          return;
        }
        this.verifycodeBtnText = `重发${codeTime}`;
      }, 1000);
      setTimeout(() => {
          this.getCodeState = true;
      }, codeTime * 1000);
    },
    async myGiftBtn() {
        if (this.phoneNumber === "") return Toast("手机号不能为空");
        if (!this.expofPhone.test(this.phoneNumber)) return Toast("手机号格式不正确");
        if (this.phoneCode === "") return Toast("验证码不能为空");
        const toastLoading = Toast.loading({
          message: "正在加载",
          forbidClick: true,
          duration: 0
        });
        let params = {
          cellPhone: this.phoneNumber,
          randomNum: this.phoneCode,
          requestSource: devicetype().name,
          pageCode: "login_page",
          caller: "luckDraw"
        }
        let {data: result} = await this.$get('verification', params);
        toastLoading.clear();
        if (result.code !== 200) return Toast(result.errMsg);
        let info = {};
        if (result.data.isNew) {
          info = {
            userInfo: {
              phone: this.phoneNumber,
              code: this.phoneCode,
              isNew: 1
            },
            actInfo: this.actInfo
          }
        } else {
          info = {
            userInfo: {
              phone: this.phoneNumber,
              code: this.phoneCode,
              isNew: 0,
              ...result.data.user
            },
            actInfo: this.actInfo
          }
        }
        // 若验证码验证成功（会拿到用户信息），则再一次缓存信息：
        if (this.$route.query.utm_source) Object.assign(info, {source: this.$route.query.utm_source});
        this.SET_GroundMarketingInfo(info);
        this.$router.push({name: "groundMarketingGiftList"});
    },
    // 点击抽奖：
    async confirmBtn() {
      try {
        if (!this.confirmBtnFlag) return false;
        if (this.isPastDue) return Toast("活动已过期");
        if (this.phoneNumber === "") return Toast("手机号不能为空");
        if (!this.expofPhone.test(this.phoneNumber)) return Toast("手机号格式不正确");
        if (this.phoneCode === "") return Toast("验证码不能为空");
        this.confirmBtnFlag = false;
        const toastLoading = Toast.loading({
          message: "正在加载",
          forbidClick: true,
          duration: 0
        });
        let params = {
          cellPhone: this.phoneNumber,
          randomNum: this.phoneCode,
          // cid: this.cid
          requestSource: devicetype().name,
          pageCode: "login_page",
          caller: "luckDraw",
        }
        let {data: result} = await this.$get('verification', params);
        if (result.code !== 200) {
          this.confirmBtnFlag = true;
          toastLoading.clear();
          return Toast(result.errMsg);
        }
        let info = {};
        if (result.data.isNew) {
          info = {
            userInfo: {
              phone: this.phoneNumber,
              code: this.phoneCode,
              isNew: 1
            },
            actInfo: this.actInfo
          }
        } else {
          info = {
            userInfo: {
              phone: this.phoneNumber,
              code: this.phoneCode,
              isNew: 0,
              ...result.data.user
            },
            actInfo: this.actInfo
          }
        }
        // 点击抽奖，若验证码验证成功（会拿到用户信息），则再一次缓存信息：
        // if (this.$route.query.source) Object.assign(info, {source: this.$route.query.source});
        if (this.$route.query.utm_source) Object.assign(info, {source: this.$route.query.utm_source});
        this.SET_GroundMarketingInfo(info);
        // 验证完成直接抽奖并且跳转至列表页面：
        // 原本逻辑是先展示奖品：
        // this.$router.push({ name: "groundMarketingGiftDraw"});
        // 此时是直接跳转至列表页面：
        this.confirmBtnFlag = true;
        this.newluckDraw(info);
      } catch(err) {
          console.log(err);
      }
    },
    // 抽奖：
    async newluckDraw(info) {
      try {
        if (!this.getGroundMarketingInfo) return;
        const toastLoading = Toast.loading({
          message: "正在加载",
          forbidClick: true,
          duration: 0
        });
        let params = {
          phone: info.userInfo.phone,
          id: info.actInfo.id,
          source: info.source? info.source: ""
        };
        let { data: result } = await this.$get("newluckDraw", params);
        if (result.code !== 200) {
          toastLoading.clear();
          Toast(result.errMsg);
          return;
        }
        toastLoading.clear();
        this.$router.push({name: "groundMarketingGiftList"});
      } catch (err) {
        console.log(err);
      }
    },
    // 领取更多福利：
    getMoreGift(url) {
      top.window.location.href = url;
    }
  },

  beforeCreate() {
    document.title = "Domino's Pizza";
  },
  created() {
    this.id = this.$route.query.id;
    this.getDrawDetail();
  }
};
</script>

<style lang="scss">
  .van-dialog {
    border-radius: 5px;
  }
  .van-dialog__confirm, .van-dialog__confirm:active {
    color: #FFF;
    background-color: #0076B3;
  }
  .van-dialog__message {
    font-weight: bold;
    padding-top: 30px;
    padding-bottom: 30px;
  }
</style>

<style lang="scss" scoped>
/deep/.van-cell {
  width: 100%;
  height: 100%;
  // background-color: #f6f6f6;
  background-color: rgba(255, 255, 255, 0);
  line-height: 40px;
  padding-top: 0px;
  padding-bottom: 0px;
}
.home_container {
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  background-repeat: no-repeat;
  border-top: 1px solid transparent;
  // position: fixed;
  // top: 0;
  // left: 0;
  // bottom: 0;
  // right: 0;
  .header_container {
    width: 100%;
    height: 50px;
    display: flex;
    margin-top: 20px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    .logo {
      flex: 3;
      padding-left: 15px;
    }
    .centerBtn {
      flex: 2;
      padding-left: 20px;
      .RuleBtn {
        width: 90%;
        height: 100%;
        // .btn_inner {
        //   width: 100%;
        //   border-radius: 15px;
        //   font-size: 14px;
        //   height: 30px;
        //   display: flex;
        //   align-items: center;
        //   justify-content: center;
        // }
      }
    }
    .rightBtn {
      flex: 2;
      padding-left: 10px;
      .myGiftBtn {
        width: 90%;
        height: 100%;
        display: flex;
        justify-content: flex-end;
        .btn_inner {
          width: 90%;
          height: 25px;
          border-radius: 15px;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          // font-family: "方正粗圆";
        }
      }
    }
    .rightIcon {
      width: 20px;
      padding-left: 10px;
      padding-top: 5px;
      img {
        width: 50%;
      }
    }
  }
  .new_content_container {
    .new_content_title {
      height: 80px;
      text-align: center;
      display: flex;
      flex-direction: column;
      .big_title {
        flex: 1;
        color: #EA416A;
        font: normal bold 25px '黑体';
      }
      .desc_title {
        flex: 1;
        font: normal bold 22px '黑体';
      }
    }
    .new_content_input_box {
      height: auto;
      width: 90%;
      margin: 0 auto;
      border-radius: 10px;
      // margin-top: 233px;
      padding: 15px 20px;
      position: relative;
      z-index: 2;
      .new_content_input {
        height: 40px;
        background-color: rgba(255, 255, 255, .7);
        border-radius: 20px;
        .new_content_input_box_inner {
          width: 100%;
          height: 100%;
        }
        &:nth-of-type(2) {
          margin-top: 15px;
          display: flex;
          .new_content_input_box_inner {
            flex: 1;
          }
          .new_content_input_box_inner_getCodeBtn {
            width: 100px;
            height: 100%;
            line-height: 40px;
            text-align: center;
            // color: #BE9F77;
            // font-family: "方正粗圆";
          }
        }

      }
      .new_content_btn {
        height: 40px;
        width: 100%;
        margin-top: 15px;
        .new_content_btn_inner {
          width: 140px;
          height: 100%;
          border-radius: 20px;
          text-align: center;
          line-height: 40px;
          margin: 0 auto;
          // font-family: "方正粗圆";
        }
      }
      .new_content_btn02 {
        height: 40px;
        width: 100%;
        margin-top: 15px;
        .new_content_btn_inner02 {
          width: 150px;
          height: 100%;
          border-radius: 20px;
          text-align: center;
          line-height: 40px;
          margin: 0 auto;
          // font-family: "方正粗圆";
        }
      }
    }
    .new_content_rule_box {
      min-height: 200px;
      width: 90%;
      margin: 0 auto;
      border-radius: 10px;
      margin-top: 17px;
      margin-bottom: 50px;
      position: relative;
      z-index: 2;
      .new_content_rule_box_title {
        height: 40px;
        text-align: center;
        line-height: 55px;
        font-size: 18px;
        font-weight: bold;
      }
      .new_content_rule_box_content {
        padding: 0 15px;
        padding-bottom: 15px;
        font-size: 12px;
      }
    }
  }
}
</style>
